import nl from './nl/nl';
import en from './en/en';
import de from './de/de';

const locales = {
    nl_NL: nl,
    en_EN: en,
    de_DE: de,
};

export default locales;
